module.exports = __webpack_public_path__ + "static/img/10.9824fb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/10.png
// module id = wAU8
// module chunks = 0